import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Vend = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Vend" {...props}>
    <path d="M20 1C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H20ZM3 20C3 20.5523 3.44772 21 4 21H15V17H11V18H8C7.48224 18 7.0561 17.6068 7.00488 17.1025L7 17H3V20ZM17 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H17V21ZM20 19C20 19.5523 19.5523 20 19 20C18.4477 20 18 19.5523 18 19V18H20V19ZM3 15H6V13C6 12.4477 6.44772 12 7 12C7.55228 12 8 12.4477 8 13V15H11V13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13V15H15V10H3V15ZM19 10C19.5521 10.0003 20 10.4479 20 11V12H18V11C18 10.4477 18.4477 10 19 10ZM4 3C3.44772 3 3 3.44772 3 4V8H6V6C6 5.44772 6.44772 5 7 5C7.55228 5 8 5.44772 8 6V8H11V6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V8H15V3H4ZM19 4C19.5523 4 20 4.44772 20 5V8H18V5C18 4.44772 18.4477 4 19 4Z" fill="#000" />
  </StyledIcon>
));

Vend.displayName = 'Vend';

export { Vend };
